var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"month-selector"}},[_c('VueSlideBar',{attrs:{"min":1,"max":12,"value":_vm.value,"range":_vm.range,"show-tooltip":false,"paddingless":true},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }